import { useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, fmtDate } from "@/lib/api";

const FE_KEY = (process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "").trim();
const keyText = (k) => (k.present ? `Present · ends in ${k.last4 || "????"}` : "Missing");

const ApiRow = ({ id, a }) => (
  <div data-testid={`geo-api-${id}`} className="rounded-xl border border-white/10 p-4">
    <div className="flex items-center justify-between gap-3">
      <p className="text-sm font-semibold text-amber-50">{a.name}</p>
      <span data-testid={`geo-api-${id}-result`} className={`rounded-full border px-2.5 py-0.5 text-xs ${a.ok ? "border-emerald-500/40 bg-emerald-500/10 text-emerald-300" : "border-red-500/40 bg-red-500/10 text-red-300"}`}>{a.ok ? "OK" : "Failed"}</span>
    </div>
    <p className="mt-1 text-xs text-zinc-400">HTTP {a.http_status ?? "—"} · {a.google_status || "—"}</p>
    {a.error_message && <p data-testid={`geo-api-${id}-error`} className="mt-1 text-xs text-red-200">{a.error_message}</p>}
    {a.hint && <p data-testid={`geo-api-${id}-hint`} className="mt-2 text-xs font-medium text-amber-300">Fix: {a.hint}</p>}
    {a.last_error && <p data-testid={`geo-api-${id}-last-error`} className="mt-2 text-[11px] text-zinc-500">Last real failure {fmtDate(a.last_error.at)}: HTTP {a.last_error.http_status ?? "—"} {a.last_error.google_status} {a.last_error.error_message}</p>}
  </div>
);

export const GoogleMapsStatus = () => {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try { setD((await api.get("/admin/geo/diagnose")).data); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="lux-card mt-8 space-y-4 p-5 sm:p-6" data-testid="google-maps-status">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <p className="lux-eyebrow">Google Maps status</p>
          <p className="mt-1 text-xs text-zinc-500">Makes one live test call each to Geocoding, Routes and Places (New) with the server key. Keys are never shown.</p>
        </div>
        <button data-testid="geo-diagnose-button" onClick={run} disabled={busy} className="btn-gold">{busy && <Loader2 className="h-4 w-4 animate-spin" />} Run test</button>
      </div>
      {d && (
        <>
          <div className="grid gap-2 text-sm sm:grid-cols-3">
            <p data-testid="geo-provider" className="text-zinc-300">Provider: <b className="text-amber-100">{d.provider}</b> ({d.map_provider_setting})</p>
            <p data-testid="geo-server-key" className="text-zinc-300">Server key: <b className="text-amber-100">{keyText(d.server_key)}</b></p>
            <p data-testid="geo-frontend-key" className="text-zinc-300">Website key: <b className="text-amber-100">{FE_KEY ? `Present · ends in ${FE_KEY.slice(-4)}` : "Missing"}</b></p>
          </div>
          <div className="grid gap-3 md:grid-cols-3">{Object.entries(d.apis).map(([k, a]) => <ApiRow key={k} id={k} a={a} />)}</div>
        </>
      )}
    </div>
  );
};
